// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../config/screen';

export const RegisterPasswordContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const FormContentContainer = styled.div`
  margin: auto;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    max-width: 420px;
    padding-right: 1.5rem;
  };
`;

export const TitleContainer = styled.div`
  padding-top: 1.5rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 2rem;
    padding-top: 0;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-top: 0.8125rem;
    padding-bottom: 0;
  };
`;

export const Description = styled.div`
  padding: 1.5rem 0 2rem 0;
  text-align: center;
  max-width: 380px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 0 2rem 0;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1.5rem 0 2rem 0;
  };
`;

export const AlertContainer = styled.div`
  padding-bottom: 0.75rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 0.625rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-bottom: 0.5rem;
  };
`;

export const InputPasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const BackToLoginContainer = styled.div`
  padding-top: 1.5rem;
  align-items: flex-start;
  justify-content: flex-start;
  display: flex;
  flex: 1;
  min-width: 100%;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-top: 1rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-top: 1.2rem;
  };
  
  svg {
    width: 24px;
    height: 24px;
  };
`;

export const TrademarkSymbol = styled.span`
  font-size: 0.7rem;
  vertical-align: super;
`;

export const ErrorList = styled.ul`
  padding-left: 20px;
  margin-top: 0;
`;

export const TermsCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 0.5rem 0;
`;

export const TermsText = styled.span`
  flex: 1;
  font-size: 14px;
  line-height: 1.5;
`;
